import { render, staticRenderFns } from "./Presentation.vue?vue&type=template&id=ae7b6bb4&scoped=true&"
import script from "./Presentation.vue?vue&type=script&lang=ts&"
export * from "./Presentation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7b6bb4",
  null
  
)

export default component.exports